// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__24CJn","list":"PatternAutocomplete_list__2pLkR"};